export * from './reset-password.component';
export * from './reset-password-request';


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./~/angular2-template-loader!./src/app/auth/reset-password/index.ts